import { render, staticRenderFns } from "./CustomVSelect.vue?vue&type=template&id=5fa8a307"
import script from "./CustomVSelect.vue?vue&type=script&lang=js"
export * from "./CustomVSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports